import React, { useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import className from 'classnames';

import { useDispatch, useSelector } from 'react-redux';
import {
  handleSocialMocking,
  selectDevTools,
  toggleDevTools,
} from '../redux/devTools/devTools';

import styles from './DevTools.scss';
import { authLogout } from '../redux/auth/actions';
import Button from '../components/Button';

interface KeyValuePair {
  key: string;
  value: string;
}

const DevTools: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectDevTools);

  const handleToggleDevTools = () => dispatch(toggleDevTools());
  const handleLogOut = () => dispatch(authLogout());

  const [keyValuePairs, setKeyValuePairs] = useState<KeyValuePair[]>([
    { key: '', value: '' },
  ]);

  const handleChange = (index: number, field: string, value: string) => {
    const updatedPairs = [...keyValuePairs];
    updatedPairs[index] = { ...updatedPairs[index], [field]: value };
    setKeyValuePairs(updatedPairs);
  };

  const handleAddKeyValue = () => {
    setKeyValuePairs([...keyValuePairs, { key: '', value: '' }]);
  };

  const handleDispatch = () => {
    dispatch(handleSocialMocking(keyValuePairs));
  };

  const handleClear = () => {
    dispatch(handleSocialMocking(null));
  };

  useHotkeys('alt+d', () => handleToggleDevTools(), []);

  return (
    <div className={className(styles.container, { [styles.isOpen]: isOpen })}>
      <Button
        onClick={handleToggleDevTools}
        text="Close"
        style={{ width: 120, backgroundColor: 'red', color: 'white' }}
      />
      <div>
        <h1>Qm DevTools</h1>
        <p>
          A small collection of utilities to hopefully help speed up development
          or recreate hard-to-test scenarios
        </p>
      </div>
      <div style={{ marginTop: 32 }}>
        <h3>Logout</h3>
        <p>Force logout, including cleaning out redux-persist storage</p>
        <Button
          style={{ maxWidth: 100, marginTop: 16 }}
          text="Logout"
          onClick={handleLogOut}
        />
      </div>
      <div style={{ marginTop: 32 }}>
        <h3>SSO URLs</h3>
        <p>
          If you need to test a Single Sign On option that isn't configured for
          this environment, add it here
        </p>
        <div>
          {keyValuePairs.map((pair, index) => (
            <div style={{ marginTop: 16 }} key={index}>
              <input
                type="text"
                placeholder="Enter service provider"
                value={pair.key}
                style={{ width: 200 }}
                onChange={e => handleChange(index, 'key', e.target.value)}
              />
              <input
                type="text"
                placeholder="Enter mock url"
                value={pair.value}
                style={{ width: 200, marginLeft: 24 }}
                onChange={e => handleChange(index, 'value', e.target.value)}
              />
            </div>
          ))}
          <div style={{ marginTop: 32 }}>
            <Button
              style={{ width: 200 }}
              onClick={handleAddKeyValue}
              text="Add Another"
            />
            <Button
              style={{ width: 200, margin: '0 24px' }}
              onClick={handleDispatch}
              text="Update State"
            />
            <Button
              style={{ width: 200 }}
              onClick={handleClear}
              text="Reset state"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevTools;
